import styled from "@emotion/styled"
import { get } from "lodash"
import React, { useContext } from "react"
import tw from "twin.macro"
import quoteClose from "../images/quote-close.svg"
import quoteOpen from "../images/quote-open.svg"
import tailwindConfig from "../utils/tailwindConfig"
import Picture from "./Picture"
import Slider from "./Slider"
import Widow from "../utils/Widow"
import ThemeContext from "../context/theme-context"

const breakpoints = tailwindConfig.theme.screens


const widow = new Widow({ words: 3, warnings: true })

const TestimonialsBlock = ({ block, contrastText }) => {
  const testimonials = get(block, "elements.testimonials.value")

  return (
    <Slider contrastText={contrastText} autoplay={true} autoplaySpeed={8000}>
      {testimonials.map((testimonial) => {
        const id = get(testimonial, "system.id")

        return <Testimonial testimonial={testimonial} key={id} />
      })}
    </Slider>
  )
}

export default TestimonialsBlock

const StyledTestimonial = styled.div`
  ${tw`md:bg-blue mt-12 md:mb-4 md:p-6 lg:p-0 lg:mt-0 lg:bg-transparent`}
`
const Row = styled.div`
  ${tw`flex flex-wrap items-center justify-center`}
`

const ImageColumn = styled.div`
  ${tw`w-1/2 relative md:w-1/3 md:pr-12 lg:pr-0 z-20`}
  @media (min-width: ${breakpoints.lg}) {
    width: 240px;
  }
`
const Image = styled(Picture)`
  ${tw`rounded-full`}
`
const ContentColumn = styled.div`
  ${tw`my-4 w-full z-10 relative md:m-0 md:p-0 md:w-2/3 md:bg-transparent lg:bg-blue lg:p-0`}
  @media (min-width: ${breakpoints.lg}) {
    flex-grow: 1;
    margin-left: -120px;
    padding-left: 120px;
  }
`

const Blockquote = styled.blockquote`
  ${tw`bg-blue leading-loose italic text-white text-center py-8 px-10 lg:mx-auto lg:w-3/4`}
`
const Quote = styled.div`
  p:first-of-type::before,
  p:last-of-type::after {
    width: 24px;
    height: 18px;
    display: inline-block;
    vertical-align: middle;
  }
  p:first-of-type::before {
    content: url(${quoteOpen});
    margin-right: 0.5em;
    transform: translateY(-50%);
  }
  p:last-of-type::after {
    content: url(${quoteClose});
    margin-left: 0.5em;
    margin-right: -40px;
    transform: translateY(0%);
  }
`
const Attribution = styled.footer`
  cite {
    ${tw`not-italic`}
  }
  &::before {
    ${tw`block border-t border-teal w-4 my-4 mx-auto`}
    content: ' ';
  }
`

const Testimonial = ({ testimonial }) => {
  const { hydrated: isClient } = useContext(ThemeContext)
  const text = get(testimonial, "elements.text.value")
  const attribution = get(testimonial, "elements.attribution.value")
  const image = get(
    testimonial,
    "elements.image.value[0].elements.image.value[0]"
  )

  return (
    <StyledTestimonial>
      <Row>
        <ImageColumn>
          <Image image={image} cropWidth={240} cropRatio={1} />
        </ImageColumn>
        <ContentColumn>
          <Blockquote>
            <Quote
              dangerouslySetInnerHTML={{
                __html: isClient ? widow.removeWidowedText(text) : text,
              }}
            />
            {attribution ? (
              <Attribution>
                <cite>{attribution}</cite>
              </Attribution>
            ) : null}
          </Blockquote>
        </ContentColumn>
      </Row>
    </StyledTestimonial>
  )
}
